import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface TownsParams extends DefaultHttpHeaders {
  /** Filter by *postal code* */
  zipCode?: string;
  /** Name of town to filter */
  name?: string;
}

@Injectable()
export class TownsService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining Q&B towns
   * Service for obtaining Q&B towns
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundTowns
   */
  towns(params: TownsParams): Observable<ParameterResult[]> {
    const queryParams = {
      zipCode: params.zipCode,
      name: params.name,
    };

    return this.get<ParameterResult[]>({
      suffix: `/comeround/catalog/towns`,
      queryParams,
    });
  }
}
